import { type AdvantageItem } from '../types';

export function useWhyItems(): AdvantageItem[] {
  const { staticUrl } = useRuntimeConfig().public;
  return [
    {
      iconUrl: `${staticUrl}/landing/why1.png`,
      title: 'Искренние мнения',
      text: 'Без купленных отзывов. Доверься людям, которые действительно получали услуги мастеров и компаний.',
      color: '#f1f1ff',
    },
    {
      iconUrl: `${staticUrl}/landing/why2.png`,
      title: 'Не трать часы на поиск',
      text: 'Одна минута и ты увидишь всю индустрию красоты своего города. База мастеров и компаний пополняется каждый день.',
      color: '#f1f6ff',
    },
    {
      iconUrl: `${staticUrl}/landing/why3.png`,
      title: 'Красота вне времени',
      text: 'Не жди, пока мастер спит или забудет записать. Будь уверенным — услуга состоится. Ежедневно записываем 12 500+ людей.',
      color: '#fcf5fc',
    },
    {
      iconUrl: `${staticUrl}/landing/why4.png`,
      title: 'Актуальная информация',
      text: 'Мастера и компании постоянно обновляют информацию о себе и публикуют доступное для записи расписание.',
      color: '#f2f3fc',
    },
  ];
}
